import styled from "styled-components";

export const RestuarantesStyled = styled.div`
  .main_container {
    padding: 0px 30px;
  }
  .head_wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .ppl_cate_header {
      font-family: Inter;
      font-size: 32px;
      font-weight: 500;
      line-height: 30px;
      text-align: left;
      text-underline-position: from-font;
      text-decoration-skip-ink: none;
      margin-bottom: 24px;
    }
    .view_all_btn {
      color: var(--secondary-colour-300-main, #0b0b0b);
      text-align: right;
      font-family: "Poppins";
      font-size: 16px;
      font-style: normal;
      font-weight: 500;
      line-height: 20px; /* 125% */
      cursor: pointer;
    }
  }
  .list_wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 40px;
    margin-left: 0px;
    margin-right: 0px;
  }
  .list_wrapper .card-div {
    box-shadow: 0px 0px 36px 0px #0000000a;
    padding: 10px;
    display: flex;
    gap: 1%;
    margin-bottom: 20px;
    align-items: center;
    justify-content: center;
    cursor: pointer;
  }
  .image-section {
    width: 20%;
    text-align: center;
    display: flex;
    justify-content: center;
  }
  .inner-img-sec {
    width: 100%;
    height: 110px;
    border: 2px solid #f6f0f0;
    padding: 5px;
  }
  .image-section .inner-img-sec img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  .text-section {
    width: 89%;
  }
  .list_wrapper .card-div .text-section h5 {
    font-family: Inter;
    font-size: 22.54px;
    font-weight: 500;
    line-height: 27.27px;
    text-align: left;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;
    margin-top: 15px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -moz-box;
    -moz-line-clamp: 2;
    -moz-box-orient: vertical;
    display: box;
    box-orient: vertical;
    line-clamp: 2;
  }
  .list_wrapper .card-div .text-section p {
    font-family: Inter;
    font-size: 16px;
    font-weight: 400;
    line-height: 26px;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    display: -moz-box;
    -moz-line-clamp: 2;
    -moz-box-orient: vertical;
    display: box;
    box-orient: vertical;
    line-clamp: 2;
  }
  .location {
    align-items: center;
  }
  .location-section {
    display: flex;
    align-items: center;
    justify-content: start;
    margin-top: 5px;
    margin-bottom: 5px;
    gap: 10px;
    img {
      width: 16px;
    }
    p {
      margin-bottom: 0px;
      font-size: 10px !important;
      line-height: 14px !important;
    }
  }
  .button-section {
    display: flex;
    justify-content: end;

    button {
      display: inline-flex;
      margin-top: 0px;
      height: 35px;
      width: 160px;
      justify-content: center;
      align-items: center;
      gap: 8px;
      border-radius: 34px;
      background: #000;
      color: #fff;
      margin-left: auto;
      font-size: 10px;
      img {
        width: 12px;
      }
    }
  }

  // mobile view styles

  @media screen and (max-width: 767px) {
    .mobile-list_wrapper {
      grid-template-columns: repeat(1, 1fr);
    }
    .mobile-list_wrapper .card-div {
      display: block;
    }
    .mobile-list_wrapper .card-div .image-section {
      text-align: center;
      background-color: #fff9f9;
      width: 100%;

    }
    .mobile-list_wrapper .card-div .image-section img {
      width: 120px;
      height: 120px;
    }
    .mobile-list_wrapper .card-div .inner-img-sec {
     height: auto;
     width: 100%;
}
    .location{
      display: block;
    }
    .location .col-6{
     width:100%;
     max-width: 100%;
     justify-content:left;
     margin-bottom: 15px;
    }
    .location .col-6 button{
     margin-left: 0px;
     width: 100%;
    }
    .main_container {
      padding: 0px 16px;
    }
    .text-section{
      width: 100%;
    }
    .detailpage-bannerimg-text h5 {
      font-size: 20px;
    }
  }
`;
